import { render, staticRenderFns } from "./StatusSuccess.vue?vue&type=template&id=1923c99c&scoped=true"
import script from "./StatusSuccess.vue?vue&type=script&lang=js"
export * from "./StatusSuccess.vue?vue&type=script&lang=js"
import style0 from "./StatusSuccess.vue?vue&type=style&index=0&id=1923c99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1923c99c",
  null
  
)

export default component.exports